import '../element-variables.scss';
import {provideGlobalConfig} from 'element-plus/es/components/config-provider/index.mjs';
import {ElLoading} from 'element-plus/es/components/loading/index.mjs';
import {ElMessage} from 'element-plus/es/components/message/index.mjs';
import {ElMessageBox} from 'element-plus/es/components/message-box/index.mjs';
import {ElNotification} from 'element-plus/es/components/notification/index.mjs';

const localeLoaders = {
    cn: () => import(/* webpackChunkName: "element-locale-cn" */ 'element-plus/es/locale/lang/zh-cn.mjs'),
    'zh-tw': () => import(/* webpackChunkName: "element-locale-zh-tw" */ 'element-plus/es/locale/lang/zh-tw.mjs'),
    ma: () => import(/* webpackChunkName: "element-locale-ms" */ 'element-plus/es/locale/lang/ms.mjs'),
    en: () => import(/* webpackChunkName: "element-locale-en" */ 'element-plus/es/locale/lang/en.mjs'),
    ko: () => import(/* webpackChunkName: "element-locale-ko" */ 'element-plus/es/locale/lang/ko.mjs'),
    ru: () => import(/* webpackChunkName: "element-locale-ru" */ 'element-plus/es/locale/lang/ru.mjs'),
    pt: () => import(/* webpackChunkName: "element-locale-pt" */ 'element-plus/es/locale/lang/pt.mjs'),
    es: () => import(/* webpackChunkName: "element-locale-es" */ 'element-plus/es/locale/lang/es.mjs'),
    vn: () => import(/* webpackChunkName: "element-locale-vi" */ 'element-plus/es/locale/lang/vi.mjs'),
    ja: () => import(/* webpackChunkName: "element-locale-ja" */ 'element-plus/es/locale/lang/ja.mjs'),
    de: () => import(/* webpackChunkName: "element-locale-de" */ 'element-plus/es/locale/lang/de.mjs'),
    fr: () => import(/* webpackChunkName: "element-locale-fr" */ 'element-plus/es/locale/lang/fr.mjs'),
    th: () => import(/* webpackChunkName: "element-locale-th" */ 'element-plus/es/locale/lang/th.mjs'),
    uk: () => import(/* webpackChunkName: "element-locale-uk" */ 'element-plus/es/locale/lang/uk.mjs')
};

async function loadElementLocale(lang) {
    const load = localeLoaders[lang] || localeLoaders.cn;
    const mod = await load();
    return mod.default || mod;
}

export default async (app, l) => {
    const locale = await loadElementLocale(l);

    provideGlobalConfig({locale}, app, true);
    app.use(ElLoading);
    app.use(ElMessage);
    app.use(ElMessageBox);
    app.use(ElNotification);
};
